import { MyResourcesTab } from "../types";
import { WSGrid, WSPage, WSText } from "@wingspanhq/fe-component-library";
import React from "react";
import { Tabs } from "../../../components/Tabs";
import { getPathnameMyResourcesTab, PATH_MY_RESOURCES_TABS } from "../paths";
import { Redirect, Route, Switch } from "react-router-dom";
import { IndependentContractorInsuranceList } from "../components/IndependentContractorInsuranceList";
import { GeneralDocuments } from "../components/GeneralDocuments";
import { PersonalInsuranceList } from "../components/PersonalInsuranceList";
import { useModalUploadDocumentFile } from "../../../Documents/modals/useModalUploadDocumentFile";
import { useModalSelectUploadDocument } from "../components/modalSelectUploadDocument/useModalSelectUploadDocument";
import { useFlowUploadDocument } from "../../Requirements/components/FlowUploadDocument";
import { WSQueryCache } from "@ws-react-query";
import { QUERY_INSURANCE_COVERAGES } from "../../../query/insuranceCoverage/queries/useQueryInsuranceCoverages";
import { useFeatureFlags } from "../../../query/hooks/useFeatureFlags";

export const RouteMyResourcesDashboard = () => {
  const selectUploadModal = useModalSelectUploadDocument();
  const featureFlags = useFeatureFlags();
  const modalUploadInsuranceFlow = useFlowUploadDocument({
    onFinish: status => {
      if (status === "success") {
        WSQueryCache.removeQueries([QUERY_INSURANCE_COVERAGES]);
      }
    }
  });

  const modalUploadDocumentFile = useModalUploadDocumentFile();

  const tabs: {
    slug: MyResourcesTab;
    label: string;
    children?: React.ReactNode;
  }[] = [
    {
      label: "Independent contractor insurance",
      slug: "independent-contractor-insurance",
      children: <IndependentContractorInsuranceList />
    },
    {
      label: "Personal insurance",
      slug: "personal-insurance",
      children: <PersonalInsuranceList />
    },
    {
      label: "General documents",
      slug: "general-documents",
      children: <GeneralDocuments />
    }
  ];

  const defaultTabPathname = getPathnameMyResourcesTab(tabs[0].slug);

  return (
    <WSPage
      title="My resources"
      primaryButton={{
        label: "Upload document",
        onClick() {
          if (featureFlags.data?.wayfinderSmartAdvanced) {
            selectUploadModal.open({
              onContinue(type) {
                if (type === "standard") {
                  modalUploadDocumentFile.open();
                } else if (type === "insurance") {
                  modalUploadInsuranceFlow.open();
                }
              }
            });
          } else {
            modalUploadDocumentFile.open();
          }
        }
      }}
    >
      <WSGrid>
        <WSGrid.Item span={{ s: "12", m: "6" }}>
          <WSText.ParagraphSm color="gray500">
            A space to store and manage the resources that you own—such as your
            uploaded documents or your insurance policies.
          </WSText.ParagraphSm>
        </WSGrid.Item>
      </WSGrid>

      <Tabs
        my="2XL"
        tabs={tabs.map(tab => ({
          label: tab.label,
          path: getPathnameMyResourcesTab(tab.slug)
        }))}
      />

      <Switch>
        <Route
          path={PATH_MY_RESOURCES_TABS}
          exact
          render={props => {
            const currentTab = tabs.find(
              tab => tab.slug === props.match.params.tab
            );

            if (!currentTab) {
              return <Redirect from="*" to={defaultTabPathname} />;
            }

            return currentTab?.children;
          }}
        />

        <Redirect from="*" to={defaultTabPathname} />
      </Switch>
    </WSPage>
  );
};
